/** The RFC 6238 time step of every TOTP code, counted from the Unix epoch. `packages/db/src/users/totp.ts`
 *  derives codes, verification steps and the provisioning URI from it; the browser countdown reads the
 *  byte-pinned mirror `web/lib/totpPeriod.ts` (tests/contract/webMirrorContracts.test.ts). */
export const TOTP_PERIOD_MS = 30_000;
